let nextMessageId = 1;

/**
 * One speech bubble from the virtual assistant.
 * speechSegments (optional) says exactly how the message is read aloud, sentence group by
 * sentence group; each segment is recorded once as its own voice clip.
 */
export default class AssistantMessage {
  constructor({ title = '', text, funFact = '', safetyNote = '', mood = 'happy', speechSegments = null }) {
    this.id = nextMessageId++;
    this.title = title;
    this.text = text;
    this.funFact = funFact;
    this.safetyNote = safetyNote;
    this.mood = mood;
    this.speechSegments = speechSegments;
  }

  getSpeechSegments() {
    if (this.speechSegments) return this.speechSegments.filter(Boolean);
    return [this.title, this.text, this.funFact && `Fun fact: ${this.funFact}`, this.safetyNote].filter(Boolean);
  }

  getSpeakableText() {
    return this.getSpeechSegments().join(' ');
  }
}
